import React, { FC } from "react";
import { Link } from "gatsby";
import classNames from "classnames";

import { Container } from "../Container/Container";
import { Button } from "../Button/Button";
import { NavLink } from "./NavLink/NavLink";
import LogoSvg from "../../assets/AdeptlyBranding.svg";

import styles from "./SiteHeader.module.scss";

export const SiteHeader: FC = () => {
	return (
		<header
			className={classNames(styles.header, {
				// [styles.isDocked]: hasScrolled,
				// [styles.isNavExpanded]: isMobileExpanded,
			})}
		>
			<Container className={styles.container}>
				<Link to="/" className={styles.home} aria-label="Home">
					<LogoSvg
						className={styles.logo}
						aria-hidden="true"
						focusable="false"
					/>
				</Link>
				{/* <Button
					className={styles.mobileCTA}
					variant="tiny"
					to="https://my.adeptly.ai/"
				>
					Start building
				</Button> */}
				{/* <button
					type="button"
					className={classNames(
						styles.mobileToggleBtn,
						"hamburger",
						"hamburger--squeeze",
						{ "is-active": isMobileExpanded }
					)}
					aria-expanded={isMobileExpanded}
					onClick={mobileMenuClickHandler}
					aria-label={isMobileExpanded ? "Close menu" : "Expand menu"}
				>
					<span className="hamburger-box">
						<span className="hamburger-inner"></span>
					</span>
				</button> */}
				<nav className={styles.nav} aria-label="Main site navigation">
					<ul className={styles.linkList}>
						{/* <li>
							<NavLink to="/pricing/">Pricing</NavLink>
						</li> */}
						<li>
							<NavLink to="/resource-centre/">Resources</NavLink>
						</li>
						<li>
							<NavLink to="/showcase/">Showcase</NavLink>
						</li>
						<li>
							<NavLink to="/community/">Community</NavLink>
						</li>
					</ul>
					<Button
						variant={"small"}
						to="https://my.adeptly.ai/"
						className={styles.cta}
						inverse
					>
						Get Started
					</Button>
				</nav>
			</Container>
		</header>
	);
};
